/** @file scopeSummary: a puppet's creation scope in a few words for its card ("16 dir · full head · iso"). */
import type { TemplateScope } from '@zilo/pose3d-commands/types/puppetInputs';

const PITCH_TEXT: Record<NonNullable<TemplateScope['pitch']>, string> = { none: 'no head pitch', basic: 'basic head', full: 'full head' };

/** Directions, head pitch and camera in that order (absent parts left out); no scope reads "template scope". */
export function scopeSummary(scope: TemplateScope | undefined): string {
  if (scope === undefined) return 'template scope';
  const parts = [
    scope.directions === undefined ? null : `${String(scope.directions)} dir`,
    scope.pitch === undefined ? null : PITCH_TEXT[scope.pitch],
    scope.camera ?? null,
  ].filter((p): p is string => p !== null);
  return parts.length === 0 ? 'template scope' : parts.join(' · ');
}
